export default {"src":"/_next/static/media/gri1.97520219.svg","height":80,"width":81,"blurWidth":0,"blurHeight":0};